import React from 'react';
import ListItem from '../ListItem';
import translate from '../../locales';
import { Grid } from '@material-ui/core';

const __t = translate;


const RuleMappingPreview = ({ name, bucketForcedRotation, bucketFreePeriod, multiplier, step, roundingType, periods }) => {
    return (
        <div>
            <div style={{ fontSize: '1.1em', overflowX: 'hidden' }}><strong>{name}</strong></div>
            <div style={{ marginTop: '5px' }}></div>
            <ListItem.ScrollableXList
                label={`${__t('periods')}:`}
                text={periods}
            />
            {bucketForcedRotation ?
                <Grid container>
                    <Grid item xs={8}>
                        <div>{__t('bucket')} {__t('forced_rotation')}: {bucketForcedRotation}</div>
                    </Grid>
                </Grid>
                :
                null
            }
            {bucketFreePeriod ?
                <Grid container>
                    <Grid item xs={8}>
                        <div>{__t('bucket')} {__t('free_periods')}: {bucketFreePeriod}</div>
                    </Grid>
                </Grid>
                :
                null
            }
            {multiplier !== null && multiplier !== undefined ?
                <Grid container>
                    <Grid item xs={12}>
                        <div>{__t('multiplier')}: {multiplier} {step ? <span>({step} {__t(roundingType.toLowerCase())})</span> : null}</div>
                    </Grid>
                </Grid>
                :
                null
            }
        </div>
    )
}

export default RuleMappingPreview;